import * as React from 'react'
import { Button, Card, CardImg } from 'react-bootstrap'
import { AiOutlineRight } from 'react-icons/ai'
import { navigate } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import { featuredProducts as addToCartStyle } from './card-basic.module.scss'

const CardBasic = ({ content, shop, url, image }) => {
  const btnText = shop ? 'Shop Now' : 'Learn More'

  return (
    <Card>
      {image ? <GatsbyImage image={image} alt={content.title} /> : ''}
      <Card.Body>
        <Card.Title className='my-3'>{content.title}</Card.Title>
        {content.description ? (
          <Card.Text className='mb-3'>
            {content.description.description}
          </Card.Text>
        ) : (
          ''
        )}
        {url ? (
          <Button
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              navigate(url)
            }}
            variant='primary'
            className={`btn-buy ${addToCartStyle}`}
          >
            {btnText}
            <span className='icon d-none d-lg-block'>
              <AiOutlineRight />
            </span>
          </Button>
        ) : (
          ''
        )}
      </Card.Body>
    </Card>
  )
}

export default CardBasic
